<template>
  <div id="footer">
    <div class="container">
      <div class="row"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footer {
  margin-top: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 10vh;
}

#footer h4 {
  padding-bottom: 0px;
}

#footer p {
  margin-bottom: 0px;
}
</style>